module.exports = __webpack_public_path__ + "img/Galactapedia_Esperia.7a410823.png";